(function($, window, document) {
	
	// Page Functions
	
	var canBeLoaded = true;

	window.PageFunctions = {
		
		setup: function() {
			this.exampleFunction('Theme Built By Roketto');
		},

		exampleFunction: function($str) {
            console.log($str);
		}

	};

})(window.jQuery, window, document); // End of jQuery wrapper



